import { Component, DestroyRef, HostListener, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import { SpacesService } from '../../services/spaces.service';
import { MatomoService } from '../../services/matomo.service';

@Component({
    selector: 'app-delete-space-modal',
    imports: [TranslateModule],
    templateUrl: './delete-space-modal.component.html',
    styleUrl: './delete-space-modal.component.scss'
})
export class DeleteSpaceModalComponent implements OnInit {
  isVisible = false;
  spaceId = '';
  private readonly destroyRef = inject(DestroyRef);

  get spaceName(): string {
    return this.spacesService.get(this.spaceId)?.name ?? '';
  }

  constructor(
    private readonly modalService: ModalService,
    private readonly spacesService: SpacesService,
    private readonly router: Router,
    private readonly matomoService: MatomoService
  ) {}

  ngOnInit(): void {
    this.modalService.modal$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(config => {
      this.isVisible = config.type === 'delete-space';
      if (this.isVisible && config.spaceId) {
        this.spaceId = config.spaceId;
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (!this.isVisible) return;
    
    if (event.key === 'Escape') {
      this.closeDialog();
    }
  }

  closeDialog(): void {
    this.modalService.closeModal();
  }

  confirmDelete(): void {
    const currentRoute = this.router.url;
    const isInDeletedSpace = currentRoute.startsWith(`/spaces/${this.spaceId}`);
    
    const deleted = this.spacesService.remove(this.spaceId);
    this.matomoService.trackActionPageView(
      this.matomoService.CATEGORY.space,
      deleted ? this.matomoService.ACTION.deleteSuccess : this.matomoService.ACTION.deleteFailed,
      'delete_space_modal'
    );
    this.closeDialog();
    
    if (isInDeletedSpace) {
      this.router.navigate(['/spaces']);
    }
  }
}
